module.exports = __webpack_public_path__ + "static/brands-react-logo-9fc2608dd2041e392ac67b7272b5fdc0.svg";